<template>
<v-container fluid class="pa-0 ma-0" style="background:#fafafa">
  <v-row justify="center" align="center" class="py-12">
  <v-col cols="12" xs="12" md="10">
    <div class="embedsocial-hashtag" data-ref="e182912b896d637aa9eb9eecb3a2ba9dbb8235d3" ></div>
  </v-col>
  </v-row>



</v-container>

</template>


<script>
// @ is an alias to /src



export default {
  name: "Home",
  components: {
    //
  },
  data: () => ({
    //
  }),
  methods: {
    //
  },
  mounted(){
    //  iFrameResize()

     (function(d, s, id){var js; if (d.getElementById(id)) {return;} js = d.createElement(s); js.id = id; js.src = "https://embedsocial.com/cdn/ht.js"; d.getElementsByTagName("head")[0].appendChild(js);}(document, "script", "EmbedSocialHashtagScript"));
  }
};
</script>



<style>
.workSansLight{
  font-family: 'Work Sans', sans-serif !important;font-weight:400;font-style: normal;
}

.workSans{
  font-family: 'Work Sans', sans-serif !important;font-weight:700;font-style: normal;
}

.playFair{
  font-family: 'Playfair Display', serif !important;font-weight:700; font-style:italic;
}


</style>
